import styled from 'styled-components';

export const ChartLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 12px;
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.Grey6};
`;

export const ChartLegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ChartLegendDot = styled.div<{ $color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
`;

export const HeatMapContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const HeatMapTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 4px;
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 12px;
`;

export const HeatMapHeaderCell = styled.th`
  padding: 8px 4px;
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 13px;
`;

export const HeatMapRowHeader = styled.td`
  padding: 2px 12px 2px 0;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 13px;
  white-space: nowrap;
  vertical-align: middle;
`;

export const HeatMapRowSublabel = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.Grey6};
`;

export const HeatMapCell = styled.td<{ $bgColor: string; $lightText?: boolean }>`
  padding: 4px 6px;
  text-align: center;
  background-color: ${({ $bgColor }) => $bgColor};
  border-radius: 4px;
  color: ${({ $lightText }) => ($lightText ? '#fff' : '#333')};
  font-size: 13px;
  font-weight: 500;
  cursor: default;
  line-height: 21px;
`;

export const DataTableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

export const StyledTable = styled.table<{ $fixedLayout?: boolean }>`
  width: 100%;
  border-collapse: collapse;
  ${({ $fixedLayout }) => $fixedLayout && 'table-layout: fixed;'}
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 12px;
`;

export const TableHeaderRow = styled.tr`
  background-color: #edeaf5;
`;

export const TableHeaderCell = styled.th<{ $sortable?: boolean }>`
  padding: 10px 8px;
  text-align: left;
  font-weight: 600;
  color: #333;
  line-height: 14px;
  font-size: 12px;
  cursor: ${({ $sortable }) => ($sortable ? 'pointer' : 'default')};
  user-select: none;

  &:hover {
    ${({ $sortable, theme }) => $sortable && `color: ${theme.colors.PrimaryDefault};`}
  }
`;

export const SortArrow = styled.span`
  margin-left: 4px;
  font-size: 10px;
`;

export const TableRow = styled.tr<{ $even?: boolean; $filler?: boolean }>`
  border-bottom: 1px solid ${({ theme }) => theme.colors.Grey3};
  background-color: transparent;

  &:hover {
    background-color: ${({ $filler }) => ($filler ? 'transparent' : '#edeaf5')};
  }
`;

export const TableCell = styled.td`
  padding: 14px 10px 14px 14px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 12px;
  overflow-wrap: break-word;
`;

export const SkipReasonsCell = styled.div`
  max-width: 280px;
  white-space: normal;
  overflow-wrap: break-word;
  line-height: 1.4;
`;

export const ChartLabelWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const ChartLabelText = styled.span`
  max-width: 100%;
  white-space: normal;
  overflow-wrap: break-word;
  text-align: right;
  line-height: 18px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
`;

export const XAxisTickLabel = styled.div`
  width: 100%;
  text-align: right;
  white-space: normal;
  overflow-wrap: break-word;
  line-height: 15px;
  font-size: 14px;
  color: #333;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 16px;
`;
